import { Form, Input, Checkbox, FormProps, Select, Upload, DatePicker, ConfigProvider, InputNumber, Typography, Button, FormInstance } from 'antd';
import { ChoiceSelect, FieldDB, MyCrudFilter } from '../../../src/interfaces/schemaDB';
import { useOne, useResource, useSelect } from '@refinedev/core';
import { CrudFilter, CrudFilters, CrudOperators } from '@refinedev/core/dist/interfaces';
import { getValueFromEvent, NumberField, TextField } from '@refinedev/antd';
import { useApiUrl } from "@refinedev/core";
import { useLocation, useParams } from 'react-router-dom';
import TextArea from 'antd/es/input/TextArea';
import { useSchemaDB } from '../../../src/hooks/useSchemaDB';
import locale from "antd/es/locale";
import dayjs from 'dayjs';
import moment from 'moment'

// import { Colorpicker, ColorPickerValue } from 'antd-colorpicker'

import esES from 'antd/es/locale/es_ES';
import { FormMode, ProviderTypes } from "interfaces/interfaces";
import { config } from "config";
import Cw8ListFieldAttachment from "./Cw8ListFieldAttachment";
import SunEditor, { buttonList } from 'suneditor-react';
import SunEditorCore from "suneditor/src/lib/core";

import dialog from "suneditor/src/plugins/modules";
import plugins from 'suneditor/src/plugins'



import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
// import 'moment/locale/es';
import React, { useEffect, useMemo, useRef, useState } from 'react'


import type { UploadFile } from 'antd/es/upload/interface';
import type { UploadProps } from 'antd';
import { nanoid } from 'nanoid'
// import {katex} from 'katex'
import katex from 'katex'
import { SunEditorReactProps } from 'suneditor-react/dist/types/SunEditorReactProps';
import { reviewPlugin } from './reviewPlugin';
// import { reviewPluginPro } from './reviewPluginPro';

import mention  from 'suneditor/src/plugins/dialog/mention';
import Cw8Wysi from './Cw8Wysi';



// import { reviewPlugin } from './reviewPlugin ';
    
// import { customDatePlugin } from './customDatePlugin';



const { Text, Title, Link } = Typography;

const idiomaMap = {
    spa: "es",
    eng: "en",
    por: "pt",
    fra: "fr",
    ita: "it",
    ale: "de",
    mul: "mul", 
    otr: "other", 
};
    
interface Cw8FieldProps{
    field: FieldDB
    filterList?: CrudFilters | undefined
    formMode : FormMode
    record?: any
    resourceName : string
    form : FormInstance
    editorRefs?: React.MutableRefObject<Record<string, any>>;
}

const clearDependenciesMap: Record<string, string[]> = {
  bv_tipologiaGeneral: ["bv_dc_tipo"],
  bv_vp_nivel1: ["bv_vp_nivel2"],
};

const Cw8Field = ({field, filterList, record, formMode, resourceName, form, editorRefs}: Cw8FieldProps ) => {

    const { id } = useParams();

    const {getProperty} = useSchemaDB( {nameTable:""})
    const getValueField = (name: string):string|undefined =>{
        // console.log(name)
        // console.log(filterList)
        let value : string | undefined = undefined
        filterList?.map( filter =>{
            //es un LogicalFilter
            if ("field" in filter){
                if(filter.field == name){
                    value =  filter.value
                    // console.log(value)
                    return(filter.value)
                }
            }
        } )
        return value
    }

  const [valueRecord, setValueRecord] = useState<string|null|undefined>( null );
// console.log(valueRecord)


useEffect( () => {
    // console.log( field.name )
    setValueRecord( getValueField(field.name) )
}, [field.name]);

    //hacer un state para gaurdar el valor

    const getValueFieldRecord = () =>{
        let value : any = ""
        if(record){
            if( field.name in record ){
                value =  record[field.name]
            }
        }
        return value
    }
    const getValueByNameFieldRecord = (name: string) =>{

        let value : any = ""
        if(record){
            if( name in record ){
                value =  record[name]
            }
        }
        return value
    }
    const getValueByNameFieldRecordResource = (name: string) =>{

        let value : any = ""
        const record  = recordResource?.data
        if(record){
            if( name in record ){
                value =  record[name]
            }
        }
        return value
    }


    // Función para homologar un string a un tipo
    function homologateCrudOperator(operator: string): Exclude<CrudOperators, "or" | "and">  {
        const validOperators: CrudOperators[] = [
            "eq", "ne", "lt", "gt", "lte", "gte", "in", "nin",
            "contains", "ncontains", "containss", "ncontainss",
            "between", "nbetween", "null", "nnull",
            "startswith", "nstartswith", "startswiths", "nstartswiths",
            "endswith", "nendswith", "endswiths", "nendswiths",
            "or", "and"
        ];
        return operator as Exclude<CrudOperators, "or" | "and">;
    }

    //tomar la información del recurso principal que viene de la URL
    const {  id : idRecordMain } = useResource();
    const { data : recordResource } = useOne({
        resource: resourceName,
        id :idRecordMain,
    });


    const getFiltersQuery = ( filters : MyCrudFilter[], record : any) : CrudFilter[] | undefined  =>{

        const expresionRegular: RegExp = /^\[.*\]$/;
        const newFilters: CrudFilter[] = [];
        for (const filter of filters) {
            newFilters.push({ 
                field : filter.field 
                , operator: homologateCrudOperator(filter.operator)
                , value : expresionRegular.test(filter.value)?getValueByNameFieldRecordResource(filter.value.replace(/\[|\]/g, '')):filter.value  
            });
        }
        return newFilters 
    }

    const nivel1Value = Form.useWatch("bv_vp_nivel1", form);
    const tipologiaGeneralValue = Form.useWatch("bv_tipologiaGeneral", form);

    const dynamicFilters: CrudFilters | undefined = useMemo(() => {
        const filters: CrudFilters = [];

        if (field.name === "bv_vp_nivel2" && nivel1Value) {
            filters.push({
                field: "niv2_nivel1",
                operator: "eq",
                value: nivel1Value,
            });
        }

        if (field.name === "bv_dc_tipo" && tipologiaGeneralValue) {
            filters.push({
                field: "tip_tipoGeneral",
                operator: "eq",
                value: tipologiaGeneralValue,
            });
        }

        return filters.length > 0 ? filters : undefined;
    }, [field.name, nivel1Value, tipologiaGeneralValue]);


const { queryResult, onSearch } = useSelect({
    resource: field.options?.linkedTableName ?? "",
    pagination: {
        current: 0,
        pageSize: 100,
        mode: "server",
    },
    liveMode: "auto",
    filters: dynamicFilters, // ✅ correcto tipo: CrudFilters | undefined
});

    const optionsSelect = queryResult.data?.data.map((item) => ({
        label: getProperty(item, field.options?field.options.fieldTxt:"title" )
        , value: ((formMode==FormMode.search ) && config.provider == ProviderTypes.airTable )?getProperty(item, field.options?field.options.fieldTxt:"id" ):getProperty(item, field.options?field.options.fieldId:"id" ) //esto funciona para apis customm, para edit e insert funciona así en airtable
        // , value: getProperty(item, field.options?field.options.fieldTxt:"id" ) //esto funciona para airtable para filtrar
    }));




    const getValueFieldRollup = () : string =>{
        let value : string = ""

        if(record){
            if( field.name in record ){
                value =  record[field.name]

                if(field.options){
                    if(field.options.result && field.options.result.type == "percent"){

                        console.log(parseFloat(value)*10000)
                        value = (Math.ceil(parseFloat(value)*10000)/100).toString()+"%"
                        console.log(value)
                    }
                }
                
                
            }
        }

        return value
    }

    const optionsSingleSelect = (field: FieldDB): ChoiceSelect[] | undefined =>{
        if(field.options){
            field.options.choices?.map( item => { item.value=item.id; item.label=item.name } ) //no funciona create
            // field.options.choices?.map( item => { item.value=item.id; item.label=item.name } )
          return field.options.choices
        }
    }

    const formatter = (value: number) => `${value}%`;
    const parser = (value: string) => value.replace('%', '');


    // UPLOAD FIELD

// console.log( getValueFieldRecord() );

    const [fileList, setFileList] = useState<UploadFile[]>(
        getValueByNameFieldRecord(field.name) != '' ?
        [{
            uid: '-1',
            name: getValueByNameFieldRecord(field.name),
            status: 'done',
            // url: 'http://localhost/lumen/verbo/verbo/public/publications/0/1/images/field.jpg',
        }]:[]
    );

    useEffect( () => {
        // console.log(fileList)
    }, [fileList]);    

    useEffect( () => {
        setFileList(
            getValueByNameFieldRecord(field.name)  ?
            [{
                uid: '-1',
                name: getValueByNameFieldRecord(field.name),
                status: 'done',
                // url: 'http://localhost/lumen/verbo/verbo/public/publications/0/1/images/field.jpg',
            }]:[]
        )
    }, [field]);    

    const handleChange: UploadProps['onChange'] = (info) => {
        let newFileList = [...info.fileList];

        // 1. Limit the number of uploaded files
        // Only to show two recent uploaded files, and old ones will be replaced by the new
        newFileList = newFileList.slice(-2);

        // 2. Read from response and show file link
        newFileList = newFileList.map((file) => {
        if (file.response) {
            // Component will show file.url as link
            file.url = file.response.url;
        }
        return file;
        });

        setFileList(newFileList);
    };

    

    const editorRef = useRef<SunEditorCore>();

    const getSunEditorInstance = (fieldName: string) => (editor: SunEditorCore) => {
        if(editorRefs){
            editorRefs.current[fieldName] = editor;
        }
    };
    
    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
    if (name === "bv_dc_title_original") {
        const title = e.target.value;
        console.log(title)

        // Obtener el valor del campo 'id'
        const idValue = form.getFieldValue("id");

        // Generar el slug
        const generatedUrl = title
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .replace(/\s+/g, "-");

        // Concatenar el ID si existe
        const fullUrl = idValue ? `${generatedUrl}-${idValue}` : generatedUrl;

        form.setFieldsValue({ bv_dc_url_vpro: fullUrl });
    }
    };



    const traducirTexto = async (
        campoOrigen: string,
        campoDestinoEsp: string,
        campoDestinoEng: string,
        keyWords?: boolean
      ) => {
        const input = document.querySelector(`input[id="${campoOrigen}"]`) as HTMLInputElement | null;
        const inputEsp = document.querySelector(`input[id="${campoDestinoEsp}"]`) as HTMLInputElement | null;
        const inputEng = document.querySelector(`input[id="${campoDestinoEng}"]`) as HTMLInputElement | null;
        const idiomaInput = form.getFieldValue("bv_dc_lenguaje");

        const idioma = idiomaMap.hasOwnProperty(idiomaInput)
            ? idiomaMap[idiomaInput as keyof typeof idiomaMap]
            : "unknown";
        
      
        if (input && inputEsp && inputEng && idioma) {
          const texto = input.value;
      
          try {
            const [resEs, resEn] = await Promise.all([
              fetch(`${config.urlAPI}/translate`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ text: texto, from: idioma, to: "es" }),
              }),
              fetch(`${config.urlAPI}/translate`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ text: texto, from: idioma, to: "en" }),
              }),
            ]);
      
            if (!resEs.ok || !resEn.ok) throw new Error("Error en la traducción");
      
            const dataEs = await resEs.json();
            const dataEn = await resEn.json();
            const textoEs = dataEs.data.translatedText;
            const textoEn = dataEn.data.translatedText;
      
            const valuesToUpdate: Record<string, string> = {};
      
            if (idioma === "es") {
              inputEsp.value = texto;
              inputEng.value = textoEn;
              valuesToUpdate[campoDestinoEsp] = texto;
              valuesToUpdate[campoDestinoEng] = textoEn;
            } else if (idioma === "en") {
              inputEng.value = texto;
              inputEsp.value = textoEs;
              valuesToUpdate[campoDestinoEng] = texto;
              valuesToUpdate[campoDestinoEsp] = textoEs;
            } else {
              inputEsp.value = textoEs;
              inputEng.value = textoEn;
              valuesToUpdate[campoDestinoEsp] = textoEs;
              valuesToUpdate[campoDestinoEng] = textoEn;
            }
      
            form.setFieldsValue(valuesToUpdate);
      
            if (keyWords) {
              const inputDescripcion = document.querySelector(`input[id="bv_dc_descripcion"]`) as HTMLInputElement | null;
              const inputAbstract = document.querySelector(`input[id="bv_abstract"]`) as HTMLInputElement | null;
              const inputSubjectSpa = document.querySelector(`input[id="bv_dc_subject_spa"]`) as HTMLInputElement | null;
              const inputSubjectEng = document.querySelector(`input[id="bv_dc_subject_eng"]`) as HTMLInputElement | null;
      
              const valoresKeywords: Record<string, string> = {};
      
              if (inputDescripcion && inputSubjectSpa) {
                const resKeySpa = await fetch(`${config.urlAPI}/getKeyWords`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ text: inputDescripcion.value }),
                });
      
                if (!resKeySpa.ok) throw new Error("Error obteniendo keywords español");
                const dataSpa = await resKeySpa.json();
                inputSubjectSpa.value = dataSpa.data.keyWords;
                valoresKeywords["bv_dc_subject_spa"] = dataSpa.data.keyWords;
              }
      
              if (inputAbstract && inputSubjectEng) {
                const resKeyEng = await fetch(`${config.urlAPI}/getKeyWords`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ text: inputAbstract.value }),
                });
      
                if (!resKeyEng.ok) throw new Error("Error obteniendo keywords inglés");
                const dataEng = await resKeyEng.json();
                inputSubjectEng.value = dataEng.data.keyWords;
                valoresKeywords["bv_dc_subject_eng"] = dataEng.data.keyWords;
              }
      
              form.setFieldsValue(valoresKeywords);
            }
          } catch (error) {
            console.error("Error al traducir o extraer keywords:", error);
          }
        } else {
          console.warn("Faltan inputs o idioma no definido");
        }
    };

    async function actualizarNotaResponsabilidad() {
        try {
            const response = await fetch(`${config.urlAPI}/notaResponsabilidadBV/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            });

            if (!response.ok) {
            throw new Error("Error en la solicitud");
            }

            const data = await response.json();
            const notaResponsabilidad = data[0]?.notaResponsabilidad;

            if (notaResponsabilidad) {
                if(editorRefs){
                    editorRefs.current["bv_vp_bibliografia"]?.setContents(notaResponsabilidad);
                }

                form.setFieldsValue({
                    bv_vp_bibliografia: notaResponsabilidad,
                });
            
            } else {
            console.warn("No se encontró la nota de responsabilidad en la respuesta.");
            }
        } catch (error) {
            console.error("Ocurrió un error al actualizar el campo:", error);
        }
    }

    async function traducirAbstractADescripcion() {
    try {
        let texto = ""
        if(editorRefs){
            texto = editorRefs.current["bv_abstract"]?.getText() || ""; 
        }
        const idiomaInput = form.getFieldValue("bv_dc_lenguaje");

        const idioma = idiomaMap.hasOwnProperty(idiomaInput)
            ? idiomaMap[idiomaInput as keyof typeof idiomaMap]
            : "unknown";

        if (!texto) {
            console.warn("No hay texto en bv_abstract para traducir");
            return;
        }

        const response = await fetch(`${config.urlAPI}/translate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                text: texto,
                from: idioma,
                to: "es",
            }),
        });

        if (!response.ok) {
            throw new Error("Error en la traducción");
        }

        const data = await response.json();
        const textoTraducido = data?.data?.translatedText || "";

        if (textoTraducido) {
            // 👇 igual que notaResponsabilidad: API de traducción da texto plano, lo envolvemos en HTML
            const htmlTraducido = `<p>${textoTraducido}</p>`;
if(editorRefs){
    console.log(Object.keys(editorRefs.current || "no"))
            editorRefs.current["bv_dc_descripcion"]?.setContents(htmlTraducido);
}

            form.setFieldsValue({
                bv_dc_descripcion: htmlTraducido,
            });
        } else {
            console.warn("No se obtuvo traducción del servidor.");
        }
    } catch (error) {
        console.error("Error al traducir el abstract:", error);
    }
}





      if (field.type == "txtWithButton") {
        return (
          <div
            id={field.name}
            style={{
                position: "relative",
                marginBottom: "24px",
                alignItems: "flex-start", // Asegura que los hijos se alineen a la izquierda
                gap: "8px", // Espacio entre el editor/input y el botón
            }}
            >
            {
                (field.name === "bv_vp_bibliografia" || field.name === "bv_dc_descripcion" || field.name === "bv_abstract") ? (
                    
                 <Form.Item
                    label={field.label}
                    name={field.name}
                    rules={[{ required: true }]}
                    key={field.id ? field.id : nanoid()}
                    preserve={false}
                    style={{ marginBottom: 0, width: "100%" }}
                    >
                    <SunEditor
                    getSunEditorInstance={(editor) => {
                         console.log("Registrando editor:", field.name);
                    if(editorRefs){
                        editorRefs.current[field.name] = editor;
                    } // 👈 asigna el editor por nombre
                    }}
                    defaultValue={getValueFieldRecord()}
                    setOptions={{
                    plugins: { reviewPlugin, ...plugins },
                    katex: { src: window.katex },
                    addTagsWhitelist: "button",
                    attributesWhitelist: {
                        button: "data-title|data-authors|data-content",
                    },
                    buttonList: [
                        ['undo', 'redo'],
                        ['paragraphStyle', 'blockquote'],
                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                        ['removeFormat'],
                        ['outdent', 'indent'],
                        ['align', 'horizontalRule', 'list'],
                        ['table', 'link', 'image', 'video', 'audio'],
                        ['fullScreen', 'showBlocks', 'codeView'],
                        ['reviewPlugin'],
                        ['math']
                    ]
                    }}
                    setAllPlugins={true}
                    lang="es"
                />
                    </Form.Item>


                ) : (
                <Form.Item
                    label={field.label}
                    name={field.name}
                    rules={[{ required: true }]}
                    key={field.id ? field.id : nanoid()}
                    preserve={false}
                    style={{ marginBottom: 0, width: "100%" }} // Asegura ancho completo del Form.Item
                >
                    <Input
                    readOnly={
                        field.edit === 0 ||
                        (field.isKey === 1 && config.provider !== ProviderTypes.airTable)
                    }
                    disabled={
                        !field.edit ||
                        (field.isKey && config.provider !== ProviderTypes.airTable) ||
                        typeof getValueField(field.name) !== "undefined"
                    }
                    onChange={(e) => handleTitleChange(e, field.name)}
                    />
                </Form.Item>
                )
            }

            
            { field.name !== "bv_dc_descripcion" && (
                <Button
              onClick={() => field.name === "bv_vp_bibliografia" ? actualizarNotaResponsabilidad() : field.name === "bv_dc_title_original" ? traducirTexto("bv_dc_title_original", "bv_dc_title_spa", "bv_dc_title_eng", false)
                             : traducirAbstractADescripcion()

              }
              type="primary"
              htmlType="button"
              style={{
                position: "absolute", // Posiciona el botón respecto al contenedor padre
                top: 0,
                right: 0, // Lo coloca a la derecha
                bottom: 0, // Lo coloca abajo
                marginTop: "8px", // Espacio adicional si es necesario
              }}
            >
              { field.name === "bv_vp_bibliografia" ? `Generar Nota` : `Traducir ${field.label}` }
            </Button>
            ) }
            </div>

        );
      }
      // UPLOAD FIELD
      else if (field.type=="multipleAttachments" || field.type=="file"){

        if(formMode ==  FormMode.edit){
            return(

                    <>
                        <Form.Item label={field.label} 
                            // name={field.name}
                        >
                            <Form.Item
                                // name={field.name}
                                valuePropName="fileList"
                                getValueFromEvent={getValueFromEvent}
                                noStyle
                            >
                                <Upload.Dragger
                                    name={field.name+(fileList.length===0?"_":"")}
                                    action={`${config.urlAPI}/${resourceName}/${getValueByNameFieldRecord("id")}`}
                                    listType="picture"
                                    maxCount={1}
                                    multiple = {true}
                                    onChange = {(info) => {
                                    handleChange(info); // tu lógica existente

                                        if (info.file.status === 'done') {
                                            // Aquí obtienes la respuesta de la API
                                            const response = info.file.response;
                                            
                                            if(resourceName === "bibliotecaVirtual"){
                                            form.setFieldsValue({
                                                 bv_vp_tamano: response.bv_vp_tamano || null,
                                                });
                                            const inputTamano = document.querySelector(`input[id="bv_vp_tamano"]`) as HTMLInputElement | null;
                                            if(inputTamano){
                                                inputTamano.value = response.bv_vp_tamano
                                            }
                                            }

                                            
                                        } else if (info.file.status === 'error') {
                                            console.error('Error al subir archivo:', info.file.error);
                                        }

                                        // Actualizar el fileList como ya haces
                                        setFileList(info.fileList);
                                    }}

                                    onRemove = {(file) => {
                                        const index = fileList.indexOf(file);
                                        const newFileList = fileList.slice();
                                        newFileList.splice(index, 1);
                                        setFileList(newFileList);

                                        form.setFieldsValue({
                                            [field.name] : null,
                                        });                                    
                                    }}

                                    fileList={fileList}
                                >
                                    <p className="ant-upload-text">
                                        Drag & drop a file in this area 
                                    </p>
                                </Upload.Dragger>
                            </Form.Item>
                        </Form.Item>

                        <Cw8ListFieldAttachment  record={ getValueFieldRecord() } />        
                        {
                            (fileList.length===0)?(
                                <Form.Item
                                        name={field.name}
                                        style ={{height:"0"}}
                                    >
                                <Input value={""} type={"hidden"}></Input>
                                </Form.Item>
                            ):null
                        }

                    </>
            )            
        }

        else{
            return(
                <>

                    {/* <Form.Item
                        label={field.label}
                        rules={[
                            {
                                required: field.required?true:false,
                            },
                        ]}
                        initialValue ={ getValueField(field.name) }
                        valuePropName="fileList"
                        getValueFromEvent={getValueFromEvent}
                        name={field.name}
                    >
                    
                        <Upload 
                            beforeUpload={() => false} 
                            name={field.name}
                            listType = "picture"
                            maxCount = {1}
                            multiple = {true}
                            onChange = {handleChange}

                            onRemove = {(file) => {
                                const index = fileList.indexOf(file);
                                const newFileList = fileList.slice();
                                newFileList.splice(index, 1);
                                setFileList(newFileList);

                                form.setFieldsValue({
                                    [field.name] : null,
                                });                                    
                            }}                
                            fileList={fileList}
                        >
                            <Button >Click to Upload</Button>
                        </Upload>                
                        
                    </Form.Item>  */}

                <Form.Item label={field.label}>
                    <Form.Item
                        name={field.name}
                        valuePropName="fileList"
                        getValueFromEvent={getValueFromEvent}
                        noStyle
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Upload.Dragger
                            listType="picture"
                            multiple
                            beforeUpload={() => false}
                        >
                            <p className="ant-upload-text">
                                Drag & drop a file in this area
                            </p>
                        </Upload.Dragger>
                    </Form.Item>
                </Form.Item>
                 

                {/* <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
                </Form.Item>                  */}
                </>
            )
        }

    }
    else{
        return (
            <Form.Item
                label={field.label}
                name={field.name}
                rules={[
                    {
                        required: field.required?true:false,
                    },
                ]}
                valuePropName={field.type=="checkbox" || field.type=="check" ?"checked":undefined}
                key={field.id ? field.id : nanoid()}
                initialValue ={ getValueField(field.name) }
                preserve = {false}

                // tooltip ={ getValueField(field.name) }
                // initialValue ={ valueRecord }
                // shouldUpdate = {true}
                // getValueFromEvent = {getValueField(field.name) }
                // getValueProps = { (value:any)=>{return 5 } }
                // getValueFromEvent = { (value:any)=>{return 5 }}
            >
            
            {
                (field.type=="checkbox" || field.type=="check")?(
                    <Checkbox/>
                ):null    
            }

            {
                (field.type=="multilineText" || field.type=="area") ?(
                    <Input.TextArea rows={5} />
                ):null
            }


            {
                (field.type=="multipleRecordLinks" || field.type == "multipleLookupValues" || field.type == "cmb" )?(
                    formMode == FormMode.create?(
                        <Select options={optionsSelect} showSearch allowClear  
                        // mode="multiple" maxLength={1}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                            (option?.label ?? '').toString().toLowerCase().includes(input.toString().toLowerCase())
                            }
                            onChange={(value, option) => {
                            const normalized = value ?? null;
                            form.setFieldsValue({ [field.name]: normalized }); 
                            field.onChange?.(normalized, option);
                            }}
                            onSelect={
                                clearDependenciesMap[field.name]
                                    ? () => {
                                        const fieldsToClear = clearDependenciesMap[field.name];
                                        const clearedValues = Object.fromEntries(
                                            fieldsToClear.map(name => [name, undefined])
                                        );
                                        form.setFieldsValue(clearedValues);
                                    }
                                    : undefined
                            }
                        />
                    ):(
                        <Select options={optionsSelect} showSearch allowClear 
                        mode={ field?.options?.multiple ?"multiple":undefined}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                            (option?.label ?? '').toString().toLowerCase().includes(input.toString().toLowerCase())
                            }
                            onChange={(value, option) => {
                            const normalized = value ?? null;
                            form.setFieldsValue({ [field.name]: normalized }); 
                            field.onChange?.(normalized, option); 
                            }}
                            onSelect={
                                clearDependenciesMap[field.name]
                                    ? () => {
                                        const fieldsToClear = clearDependenciesMap[field.name];
                                        const clearedValues = Object.fromEntries(
                                            fieldsToClear.map(name => [name, undefined])
                                        );
                                        form.setFieldsValue(clearedValues);
                                    }
                                    : undefined
                            }
                            // onChange = {onSearch}
                        />
                        )
                    ):null
            }

            {field.type=="singleSelect"?(
                    <Select options={optionsSingleSelect(field)} showSearch allowClear 
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                        (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
                        }
                    />
                    ):null
            }

            
            {field.type == "date" ? (
                formMode == FormMode.search ? (
                    <DatePicker
                    format={"YYYY-MM-DD"}
                    value={dayjs(getValueFieldRecord(), "YYYY-MM-DD")}
                    />
                ) : formMode == FormMode.create ? (
                    <ConfigProvider locale={esES}>
                    <DatePicker
                        format={"YYYY-MM-DD"}
                        onChange={(date, dateString) => {
                        form.setFieldsValue({ [field.name]: dateString });
                        }}
                        showTime={false}
                    />
                    </ConfigProvider>
                ) : (
                    <ConfigProvider locale={esES}>
                    <Form.Item
                        name={field.name}
                        getValueProps={(value) => ({
                        value: value ? dayjs(value) : "",
                        })}
                    >
                        <DatePicker format="YYYY-MM-DD" />
                    </Form.Item>
                    </ConfigProvider>
                )
            ) : null}

            {field.type=="number" ?(
                    <InputNumber min={1}></InputNumber>       
                ):null
            } 


            {field.type=="percent" ?(
                    // <InputNumber min={1} max={100} precision={2}></InputNumber>       

                    <InputNumber defaultValue={0}
                    min={0}
                    max={100}
                    formatter={(value) => `${(value?value:0)*100}%`}
                    step = {0.01}
                    parser={(value:string | undefined) => value?parseFloat(value.toString().replace('%', ''))/100:0}
                  />
                ):null
            } 

            {field.type=="rollup" ?(
                <>
                    {/* <Title level={5}>{field.label}</Title> */}
                    {/* <TextField value = {456}  />   
                    
                    */}

                        <NumberField
                            value={getValueFieldRecord()}
                            options={{
                                notation : "standard",
                                style: 'percent',
                                maximumSignificantDigits: 3,
                                minimumSignificantDigits: 2
                            }}
                        />                    
                    {/* <p>{getValueFieldRecord()}</p> */}
                </>
                ):null
            } 

            {field.type=="txt" || field.type == "singleLineText" || field.type == "autoNumber" || field.type == "email" ?(
                    
                    
                    // !field.edit || (field.isKey && config.provider != ProviderTypes.airTable )?
                    // <>
                    // <span className="ant-form-text">{getValueField(field.name)}</span>
                    // <Input type={"hidden"} value={getValueField(field.name)} name={field.name}/>
                    // {/* <Input></Input> */}
                    // </>
                    // :
                    <Input key={field.id ? field.id : nanoid()}
                        readOnly={field.edit == 0 || (field.isKey == 1 && config.provider != ProviderTypes.airTable )} 
                        disabled={!field.edit || (field.isKey && config.provider != ProviderTypes.airTable) || typeof getValueField(field.name) != 'undefined'}  
                    />
                    
                    
                    ):null
            }                        

            {field.type=="url" ?(
                    // <Input readOnly={!field.edit || (field.isKey && config.provider != ProviderTypes.airTable )} disabled={!field.edit || (field.isKey && config.provider != ProviderTypes.airTable) || getValueField(field.name) }  />
                    <Link href={getValueFieldRecord()} target="_blank">
                    {getValueFieldRecord()}
                    </Link>                    
                    ):null
            }      

            {field.type=="color" ?(
                    // <Input readOnly={!field.edit || (field.isKey && config.provider != ProviderTypes.airTable )} disabled={!field.edit || (field.isKey && config.provider != ProviderTypes.airTable) || getValueField(field.name) }  />
                    // <Colorpicker showText />   
                    <input type="color" />                 
                    ):null
            }      
            
            
            {field.type=="wysi" ?(
                    // <Input readOnly={!field.edit || field.isKey} disabled={!field.edit || field.isKey || getValueField(field.name) }  />
                    <>

                    {/* <Cw8Wysi
                        valueField= { getValueFieldRecord() }
                        instance = {editorRef}
                    ></Cw8Wysi> */}

                    <SunEditor

                        getSunEditorInstance={(editor) => {
      if(editorRefs){
        editorRefs.current[field.name] = editor;
      }
    }}
                        // ref={editorRef}
                        // onChange = {handleEditorChange}
                        defaultValue  = { getValueFieldRecord() } 

                        setOptions={{
                            // height: 300,
                            // addTagsWhitelist: {"button"},
                            // plugins: [reviewPlugin, reviewPluginPro, mention],
                            plugins:  {reviewPlugin, ...plugins},
                            // plugins: [mention],
                            katex : {src:window.katex},
                            addTagsWhitelist : "button",
                            attributesWhitelist: {
                                "button": "data-title|data-authors|data-content"
                            },
                            buttonList: [
                                ['undo', 'redo'],
                                ...(resourceName !== "bibliotecaVirtual" ? [['formatBlock']] : []),
                                ['paragraphStyle', 'blockquote'],
                                ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                ['removeFormat'],
                                ['outdent', 'indent'],
                                ['align', 'horizontalRule', 'list'/* , 'lineHeight' */],
                                ['table', 'link', 'image', 'video', 'audio' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
                                ['fullScreen', 'showBlocks', 'codeView']
                                // , ['reviewPlugin', 'reviewPluginPro' ]
                                , ['reviewPlugin' ]
                                , ['math'
                                // , {
                                //     display: 'command',
                                //     name: 'limpiar',
                                //     // display: 'Limpiar',
                                //     title: 'Limpiar contenido',
                                //     innerHTML: 'Limpiar contenido',
                                //     action: establecerContenidoNull,
                                //     add: function (core : any, targetElement:any) {
                                //     },
                                // }                                
                            ]
                            ]
                        }}

                        setAllPlugins={true}

                        lang ='es'
                    />
                    {/* <button onClick={establecerContenidoNull}>Set null</button> */}
                    </>
                    ):null
            }   


            {field.type=="createdTime" ?(
                    // <Input readOnly={!field.edit || (field.isKey && config.provider != ProviderTypes.airTable )} disabled={!field.edit || (field.isKey && config.provider != ProviderTypes.airTable) || getValueField(field.name) }  />
                    <Text>
                    {moment( getValueFieldRecord() ).format("YYYY-MM-DD HH:mm:ss") }
                    </Text>                    
                    ):null
            }      

            {/* {field.type=="multipleAttachments" ?(
                    // <Cw8ListFieldAttachment 
                    //     record={ getValueFieldRecord() } />
                        <p>sddsfdf</p>
                    ):null
            }                         */}
                    
            </Form.Item>      
        )
    }
    
}

export default Cw8Field
